import { MenuLinkModel, brugereMenuLink, evalueringsstatistikMenuLink, klarmeldingerMenuLink, kursusoversigtMenu, nyhederMenuLink, uddannelseslaegeOverviewMenuLink, vejlederNotaterMenuLink } from "core/layout/shared/MenuLinkProps";
import { DynamicMenu } from "../DynamicMenu";
import MenuProps from "./menuProps";

export function VejlederMenu({ showNotification, nyhederMenuLink }: MenuProps) {

    const menuLinks: Array<MenuLinkModel> = [
        uddannelseslaegeOverviewMenuLink,
        klarmeldingerMenuLink,
        vejlederNotaterMenuLink,
        brugereMenuLink,
        evalueringsstatistikMenuLink,
        nyhederMenuLink,
        kursusoversigtMenu
    ];

    return (
        <DynamicMenu menuLinks={menuLinks} showNotifications={showNotification}/>
    );
}
